<div class="modal-header">
    <h4 class="modal-title">Kontakt {{ title }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="newForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label class="control-label" for="inputAnsprechpartner">Ansprechpartner<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="inputAnsprechpartner" name="ansprechpartner" placeholder="Ansprechpartner" formControlName="ansprechpartner">
        </div>
        <div class="form-group">
            <label class="control-label" for="inputTelefon">Telefon<span class="text-danger">*</span></label>
            <input type="tel" class="form-control" id="inputTelefon" name="telefon" placeholder="Telefon" formControlName="telefon">
        </div>
        <div class="form-group">
            <label class="control-label" for="inputEmail">E-Mail<span class="text-danger">*</span></label>
            <input type="email" class="form-control" id="inputEmail" name="email" placeholder="E-Mail" formControlName="email">
        </div>
        <div class="form-group">
            <label class="control-label" for="inputNotizen">Notizen</label>
            <textarea type="text" class="form-control" id="inputNotizen" name="notizen" placeholder="Notizen" formControlName="notizen"></textarea>
        </div>
      </form>
  </div>
  <div class="modal-footer">
  <button type="submit" class="btn btn-success round" (click)="onSubmit()">Hinzufügen</button>
  <button type="reset" class="btn round bg-red" style="color: white;" (click)="activeModal.close('Schließen')">Schließen</button>
  </div>
